import { useInfiniteQuery } from "@tanstack/react-query";
import { stockApi, type StockHistoryFilters } from "@/lib/admin-api/stock";

export function useStockHistory(
  productId: string,
  filters: Omit<StockHistoryFilters, "cursor"> = {},
) {
  return useInfiniteQuery({
    queryKey: ["admin", "stock-history", productId, filters],
    queryFn: ({ pageParam }) =>
      stockApi.history(productId, { ...filters, cursor: pageParam }),
    initialPageParam: undefined as string | undefined,
    getNextPageParam: (lastPage) => lastPage.next_cursor ?? undefined,
    enabled: Boolean(productId),
  });
}
